import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { ContactFormModal } from "./ContactFormModal";
import useUserStore from "../stores/user";
import { useUiLang } from "../stores/uiLang";

export function FloatingContactButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const profile = useUserStore((s) => s.profile);
  const lang = useUiLang();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Run E2 J2: K-5 students do not get the adult support form (it asks for a
  // full name and email). The footer "Contact" link is hidden for them too.
  if (profile?.role === "student") return null;
  const label = lang === "es" ? "Contactar a soporte" : "Contact Support";

  return (
    <>
      <button
        onClick={openModal}
        className="fixed bottom-6 right-6 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full p-4 shadow-lg transition-all duration-200 hover:scale-110 z-40 group"
        aria-label={label}
        title={label}
      >
        <MessageCircle
          size={24}
          className="group-hover:rotate-12 transition-transform duration-200"
        />
      </button>

      <ContactFormModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
}
